module.exports = __webpack_public_path__ + "img/christine-half.a8aacdde.png";